import React from 'react';
import { Box, Link, Grid } from '@material-ui/core';

class BottomBar extends React.Component {
    render() {
        return (
            <>
                {this.props.bottomText && (
                    <Grid container>
                        <Grid item xs style={{ height: '100%' }}>
                            <Box
                                sx={{
                                    height: 40,
                                    width: '100%',
                                    justifyContent: 'center',
                                    display: 'flex',
                                    borderTop: '1px solid #919EAB3D',
                                    flexDirection: 'column',
                                    textAlign: 'right',
                                    bottom: 0,
                                    position: 'fixed',
                                    bgcolor: 'white',
                                }}
                            >
                                {this.props.bottomText.openIn === 'tab' && (
                                    <Link
                                        variant="body2"
                                        color="primary"
                                        rel="noopener noreferrer"
                                        target="blank"
                                        href={this.props.bottomText.url}
                                    >
                                        {this.props.bottomText.text} &nbsp;
                                    </Link>
                                )}
                                {this.props.bottomText.openIn !== 'tab' && (
                                    <Link variant="body2" color="primary" href={this.props.bottomText.url}>
                                        {this.props.bottomText.text} &nbsp;
                                    </Link>
                                )}
                            </Box>
                        </Grid>
                    </Grid>
                )}
            </>
        );
    }
}

export default BottomBar;
